module.exports = __webpack_public_path__ + "img/c99a00f.png";